<template>
  <v-row justify="center" wrap>
    <v-col cols="6" class="py-0">
      <span class="title">Contacts</span>
    </v-col>
    <v-spacer />
    <v-col cols="6" md="4" class="py-0">
      <v-text-field v-model="filter" class="mt-0 pt-0" clearable hide-details placeholder="Filter contacts" />
    </v-col>
    <template v-if="!filteredContacts || filteredContacts.length < 1">
      <v-col cols="12">
        <v-card>
          <v-card-text>No Contacts Found</v-card-text>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      <v-col v-for="(c, idx) in filteredContacts" :key="idx" cols="12" class="py-1">
        <Contact :contact="c" @phone-clicked="handlePhoneClick" @email-clicked="handleEmailClick" />
      </v-col>
    </template>
    <v-col v-if="contacts.length < totalCount" cols="12">
      <div class="caption text-center px-4">
      <v-btn color="blue2" outlined block @click="getContacts">Load More</v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<style>
</style>

<script>
import analyticsService from '@/services/shared/analyticsService.js';
import apiService from '@/services/shared/agentPortalApiService.js';
import { mapState, mapActions } from 'vuex';
import Contact from '@/components/Client/Contact.vue';

export default {
  name: 'ProfileContacts',
  components: {
    Contact
  },
  data: function () {
    return {
      contacts: [],
      totalCount: 0,
      filter: ''
    };
  },
  computed: {
    ...mapState(['selectedProfileId']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    profileId: function () {
      return this.selectedProfileId;
    },
    filteredContacts: function () {
      if ((this.contacts || null) === null) return [];

      if ((this.filter || null) === null || this.filter === '') {
        return this.contacts;
      } else {
        return this.contacts.filter((x) => x.data.toLowerCase().includes(this.filter.toLowerCase()));
      }
    }
  },
  watch: {
    profileId: async function (val) {
      if (val != null && val > 0) {
        await this.getContacts();
      }
    }
  },
  mounted: async function () {
    await this.getContacts();
  },
  methods: {
    ...mapActions(['setError']),
    async getContacts () {
      var rs = await apiService.getProfileContacts(this.clientId, this.profileId, this.contacts.length);
      if (rs.code === 0) {
        this.totalCount = rs.data[0].totalCount;

        if ((this.contacts || null) === null) {
          this.contacts = rs.data[0].data;
        } else {
          this.contacts = this.contacts.concat(rs.data[0].data);
        }
      } else {
        this.setError(rs.message);
      }
    },
    handlePhoneClick: function (val) {
      analyticsService.sendEvent(this.$gtag, 'Call', 'Client', 'Person Call');
    },
    handleEmailClick: function (val) {
      analyticsService.sendEvent(this.$gtag, 'Email', 'Client', 'Person Email');
    }
  }
};
</script>
